export var Routes;
(function (Routes) {
    Routes["MAIN"] = "/";
    Routes["SETTINGS"] = "/settings";
    Routes["SHARE"] = "/share";
})(Routes || (Routes = {}));
